import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import "./EventProductPageNew.css";
import { Link } from "react-router-dom";

const images = [
  "/assests/images/gallery-slide-new1.jpg",
  "/assests/images/gallery-slide-new2.jpg",
  "/assests/images/gallery-slide-new3.jpg",
  "/assests/images/gallery-slide-new4.jpg",
  "/assests/images/gallery-slide-new5.jpg",
  "/assests/images/gallery-slide-new6.jpg",
  "/assests/images/gallery-slide-new7.jpg",
  "/assests/images/gallery-slide-new8.jpg",
  "/assests/images/gallery-slide-new9.jpg",
  "/assests/images/gallery-slide-new10.jpg",
  "/assests/images/gallery-slide-new11.jpg",
  "/assests/images/gallery-slide-new12.jpg",
];

const EventProductPageNew = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    document.title = `Event Product | Your Friend My Friend`;
    document.getElementById("bodywrap").className = "products";
  }, []);

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src="/assests/images/event-product-new-1.png"
          alt="QR Code"
          className="img-fluid d-none d-md-block"
        />

        <svg viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" focusable="false"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>

        {/* Mobile Image */}
        <img
          src="/assests/images/event-product-new-1.png"
          alt="QR Code"
          className="img-fluid d-block d-md-none"
          style={{ objectPosition: 'unset' }}
        />
      </div>

      <div className="container-fluid wiklo">
        <div className="row">
          {/* Left Section - Event Details */}
          <div className="col-lg-7 wiklo-left">
            <div className="spp">SINGLES SOCIAL</div>
            <h2>YFMF Singles Pavilion at Punchestown Racecourse Festival 2026</h2>
            <div className="d-flex gap-2 mb-3 mt-3 flex-wrap">
              <h4>Saturday, May 2nd 2026</h4>
              <h5>12:00 - 21:00</h5>
              <h6>Punchestown, Naas</h6>
            </div>
            <h3>
              Get ready for our biggest event yet! YFMF and Punchestown Racecourse are teaming up to bring you the YFMF Singles Pavilion at Punchestown Festival 2026.
            </h3>
            <p>Set against the backdrop of Ireland’s most iconic racing festival, this is a full day social experience combining elite sport, fashion, food, music and atmosphere. All curated for singles who want something bigger, better and brilliantly social.</p>
            <p>
              Expect a vibrant crowd of 500 singles enjoying racing at its best, a buzzing private pavilion overlooking the track, live entertainment throughout the day and the unmistakable energy that only Punchestown delivers.
            </p>

            <div className="acco-banner mt-5">Your ticket includes</div>
            <div className="row">
              <div className="col-md-12">
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          The Festival Experience
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Access to the Punchestown Racecourse Festival, one of Ireland’s most celebrated social and sporting events. From renowned Race & Dine experiences to casual food stalls and bars across the grounds, Punchestown offers exceptional choice for food and drink throughout the day, all within a lively festival atmosphere.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          The YFMF Singles Pavilion
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      YFMF guests enjoy exclusive access to our private Singles Pavilion overlooking the racecourse.
                      <ul className="mb-0 mt-2">
                        <li>A welcome drink on arrival</li>
                        <li>500 singles in one dedicated social space</li>
                        <li>DJ and entertainment throughout the day</li>
                        <li>A high energy, stylish atmosphere designed for natural connection</li>
                        <li>Access to the YFMF AfterChat post event, allowing you to reconnect after the day</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">Racing, With Insight</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Enjoy a premium elevated view of the track from the pavilion, alongside a guest tipster who will guide guests through the racecard. <br /> <br />
                      Whether you are a seasoned racegoer or completely new, you will gain insight into how the racing works, what to look out for, and where the value may lie should you choose to place a bet.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">Music & Entertainment</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Punchestown is as much about celebration as it is about racing. <br /> <br />
                      Following the final race, the party continues with live music and an après racing DJ set. Guests will also have access to the Sky Bar, featuring a live DJ throughout the day, making this a seamless transition from sporting spectacle to full festival mode.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>


            <h1>Getting There</h1>
            <p>
              For those who wish to arrange transport, optional return bus transfers will be available to purchase from Dublin City Centre to Punchestown Racecourse.
            </p>
            <p>
              Buses will depart from Dublin City Centre and return at the end of the day, allowing you to enjoy the full festival experience without worrying about driving or parking.
            </p>
            <p>Transport tickets will be sold separately. Full details, including departure points, timings and booking information, will be emailed to all ticket holders closer to the event date.</p>

            <div className="real-connection ner-real ps-0 pe-0 pb-2 pt-4">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-between align-items-center mb-2">
                  <div className="slidees ols">
                    <h2>Event Gallery</h2>
                  </div>
                  <div className="d-none d-md-flex justify-content-start">
                    <button
                      className="btn"
                      onClick={() =>
                        setIndex(index === 0 ? images.length - 1 : index - 1)
                      }
                    >
                      <img
                        src="/assests/images/carousel-left.png"
                        className="img-fluid"
                        alt=""
                      />
                    </button>
                    <button
                      className="btn"
                      onClick={() =>
                        setIndex(index === images.length - 1 ? 0 : index + 1)
                      }
                    >
                      <img
                        src="/assests/images/carousel-right.png"
                        className="img-fluid"
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="col-md-12">
                  <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                    indicators={false}
                    controls={false}
                    interval={5000}
                    wrap={true}
                    slide={true}
                    className="custom-carousel p-0"
                  >
                    {images.concat(images[0]).map((img, i) => (
                      <Carousel.Item key={i}>
                        <div className="carousel-images">
                          <img
                            src={img}
                            className="img-fluid main-img"
                            alt={`Slide ${i}`}
                          />
                          {images[(i + 1) % images.length] && (
                            <img
                              src={images[(i + 1) % images.length]}
                              className="img-fluid extra-img"
                              alt={`Slide ${(i + 1) % images.length}`}
                            />
                          )}
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>

                <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
                  <button
                    className="btn"
                    onClick={() =>
                      setIndex(index === 0 ? images.length - 1 : index - 1)
                    }
                  >
                    <img
                      src="/assests/images/carousel-left.png"
                      className="img-fluid"
                      alt=""
                    />
                  </button>
                  <button
                    className="btn"
                    onClick={() =>
                      setIndex(index === images.length - 1 ? 0 : index + 1)
                    }
                  >
                    <img
                      src="/assests/images/carousel-right.png"
                      className="img-fluid"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <h1>Race Schedule</h1>
            <p className="mb-0">
              Festival Saturday is the ultimate wrap party for the Irish jump racing season.
            </p>
            <p className="mb-0">
              Festival goers of all ages travel from every corner of Ireland and beyond to celebrate the achievements of Irish jump racing. The racing fans of tomorrow are entertained in the Junior Jockey Club Fun Zone whilst the season champions are crowned in the winners enclosure.
            </p>
            <p>*Please note the timings are subject to change.</p>
            <p>TIME   RACE</p>
            <p className="mb-0">14:30   The HOWDEN Cross-Country Chase of €15,000</p>
            <p className="mb-0">15:05   The Punchestown Handicap Chase of €50,000</p>
            <p className="mb-0">15:40   The GR1 SBK Irish EBF Mares Champion Hurdle of €125,000</p>
            <p className="mb-0">16:15   The Palmerstown House Pat Taaffe Listed Handicap Chase of €50,000</p>
            <p className="mb-0">16:50   The GR1 Ballymore Champion Four Year Old Hurdle of €125,000</p>
            <p className="mb-0">17:25   The Lawlors of Naas Listed Handicap Hurdle of €100,000</p>
            <p className="mb-0">18:00   The Punchestown (Pro-Am) Flat Race</p>
            <p className="mb-5">18:35   The Punchestown Kidney Research Fund Charity Race</p>


            <div className="acco-banner">Frequently Asked Questions</div>
            <div className="row">
              <div className="col-md-12">
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Where is Punchestown?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Punchestown is situated 5 minutes outside of Naas Town. It can be easily accessed with all major road and rail services nearby.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Will there be a even male/female split in the YFMF Singles Pavilion?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Yes, we aim to have as close to a 50/50 split of male to females in the YFMF Singles Pavilion.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Do I have access to the rest of the festival?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Yes, if you purchase a ticket to the Singles Pavilion you will also have full access to the Festival including an elevated view of the races, access to all bars and food facilities and SkyBar.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          How can I purchase a ticket to the Punchestown Singles Pavilion?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Click the ‘Get Tickets’ button and book your tickets prior to the event. Tickets are purchased through Punchestown Festival. Terms & Conditions can be found here.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Do you offer refunds?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Punchestown cancellation charges are as follows;<br />
                      i. The deposit is retained in full in the event of client cancellation for any reason.<br />
                      ii. If client cancels more than 30 days from the event 50% of the balance (full costs less deposit) will be returned to the client.<br />
                      iii. If the client cancels less than 30 days from the event then no refund will be issued
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          How do I get to Punchestown Racecourse?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Punchestown is easily accessible for all modes of transport. Click here to view your options.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          What time should I arrive to the racecourse?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Gates typically open 90mins before the first race on all season race days aside from the Festival where they open two hours before the first.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Are there busses to the festival?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      Yes, you can visit our travel partner <Link to="" className="text-black">Marathon Travel</Link> to avail of a return service to and from Dublin City Centre to Punchestown.<br /> <br />
                      Andy’s of Naas will be running shuttle services to / from the track from Naas town.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          What bars and food facilities are on site?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      The Main Grandstand is host to the Archive, Loft & Sports Bar. The singles Pavilion will also have two bars within the venue. There are plenty of food options to choose from on the day of the event.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      <div className="d-flex flex-column">
                        <div className="juyyy mt-0">
                          Is there a cloakroom?
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="mt-3">
                      No, there is no cloakroom on site.
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </div>
            </div>
          </div>

          <div className="col-lg-1"></div>

          {/* Right Section - Ticket Card */}
          <div className="col-lg-4 wiklo-right">
            <div className="card ire-right">
              <h2>Tickets for YFMF Singles Pavilion at Punchestown Racecourse 2026</h2>
              <div className="prices pb-0">
              </div>
              <div className="arrive-new mt-1">
                <Link
                  to="https://punchestown.com/events/?pid=416"
                  className="btn bros-bu text-decoration-none w-100"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GET TICKETS
                </Link>
              </div>
            </div>
            </div>
        
        </div>
      </div>

      <Footer />
    </>
  );
};

export default EventProductPageNew;